export const environment = {
  production: false,
  devMode: false,
  uploadMaximumSizePerFile: 150 * 1024 * 1024, // ==> First unit expressed in MegaBytes
  uploadMaximumTotalSize: 300 * 1024 * 1024,
  nextPlannedUpdate: null,
  uploadMaxNbrFiles: 20,
  environmentTitle: 'Acc',
  baseUrl: 'https://api-imandat-acc.myinforius.be/api/v1',
  baseUrlProd: 'https://api-imandat-acc.myinforius.be/api/v1',
  baseUrlDocumentEditor:
    'https://infodoc-services.inforius.be/ITemplateV2/api/v2/Documenteditor/',
  baseUrlDocumentProcessor:
    'https://infodoc-services.inforius.be/ITemplateV2/api/v2/DocumentProcessor/',
  clientUri: 'https://imandat-acc.azureedge.net',
  uploadEndPoint:
    'https://api.imandat-acc.myinforius.be/api/v1/inforius/upload',
  adobeClientId: '2e6b9291cfef4970a087b5d7117edb5b',
};
